<template>
  <div class="content">
    <!-- <iframe
      src="http://lxcdn1.crtvup.com.cn/booklesson/scan/learn_pc_intro.html"
      :width="innerWidth"
      :height="innerHeight"
      class="iframe"
    ></iframe> -->
    <div class="flex-col">
      <div>国开乐学PC端课程学习操作流程：</div>
      <div style="margin-top: 20px">1.听课链接：</div>
      <div>https://web.ysy.crtvup.com.cn/#/lxvideo</div>
      <div>2.听课方法：</div>
      <div>（1）打开浏览器，输入听课链接，进入登录页面；</div>
      <div>（2）使用开放云书院APP账号及密码登录；</div>
      <div>（3）选择“课程列表”中相应课程，点击“开始学习”观看课程。</div>
      <div>3.特殊说明：</div>
      <div>（1）账号为注册app时的手机号码，密码为登录密码；</div>
      <div>（2）PC端只能在线观看课程，不能缓存</div>
      <div>（3）原乐学用户需要在开放云书院app重置密码。</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
    };
  },
  created() {
    this.innerWidth = window.innerWidth - 15;
    this.innerHeight = window.innerHeight - 15;
    // window.open(
    //   "http://lxcdn1.crtvup.com.cn/booklesson/scan/learn_pc_intro.html"
    // );
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.content {
  // width: 100%;
  padding: 30px;
  // display: flex;
  // justify-content: center;
  font-size: 15px;
}
.iframe {
  border: none;
}
.flex-col {
  display: flex;
  flex-direction: column;
  div {
    margin-top: 5px;
  }
}
</style>